import { Chip } from '@mui/material';
import { grey } from '@mui/material/colors';

export const TaskAssignedChip = (props: {
  resourceId?: string;
  targetQueue: string;
}) => {
  const { resourceId, targetQueue } = props;

  switch (targetQueue) {
    case 'egress':
      return (
        <Chip
          label="Completed"
          style={{ backgroundColor: grey[200] }}
          size="medium"
          data-testid="task-status"
        />
      );
    case 'wip_q':
      return (
        <Chip
          label="Started"
          color="success"
          size="medium"
          data-testid="task-status"
        />
      );
    case 'cancelled_q':
      return (
        <Chip
          label="Cancelled"
          color="error"
          size="medium"
          data-testid="task-status"
        />
      );
    default:
      if (resourceId) {
        return (
          <Chip
            label="Assigned"
            color="success"
            size="medium"
            data-testid="task-status"
          />
        );
      } else {
        return (
          <Chip
            label="Unassigned"
            color="error"
            size="medium"
            data-testid="task-status"
          />
        );
      }
  }
};
